import React from 'react'
import { ViewLabelStyle } from './style'
import { ViewLabelProps } from '../../types/components/viewLabel'

export const ViewLabel: ViewLabelProps = ({
  typeView = 'normal',
  label,
  value,
  widthDiv = '100%',
  heightDiv = 'normal'
}) => {
  return (
    <ViewLabelStyle widthDiv={widthDiv} heightDiv={heightDiv}>
      <label>{label}</label>
      {typeView === 'normal' && <p>{value}</p>}
      {typeView === 'large' && <textarea value={value} disabled />}
    </ViewLabelStyle>
  )
}
